/**
 * Copyright (C) Siemens AG 1996-2024 ALL RIGHTS RESERVED.
 */

import {Component} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community'; // NOSONAR
import {IxModule} from '@siemens/ix-angular';
import {TranslateModule} from '@ngx-translate/core';
import {UserDto} from '../../../../models/user-management/UserDto';

@Component({
  imports: [IxModule, TranslateModule],
  template: `
    @if (this.status === 'INVITED') {
      <div style="display: flex;">
        <ix-pill
          variant="primary"
          outline
          id="statusCellRendererStatusPill.{{ user['email'] }}"
        >
          {{ 'um.invited_label' | translate }}
        </ix-pill>
      </div>
    }
  `,
})
export class StatusCellRendererComponent implements ICellRendererAngularComp {
  public status!: string;
  public user!: UserDto;

  agInit(params: ICellRendererParams): void {
    this.user = params.data;
    this.status = params.data.status;
  }

  refresh(): boolean {
    return false;
  }
}
